import {Weight} from '../../../Domain/Weight';

export function formatBoatTypeWeight(weight: Weight) {
    return weight.kilograms.toFixed(0) + 'kg';
}
